import { MutationObserverOptions, useMutation } from '@tanstack/vue-query';
import { AxiosError } from 'axios';

import { DeleteCartItemRequest, UpdateCartOrderDetailsRequest, UpdateCartOrderDetailsResponse } from '@/models/cart';
import { deleteItem, updateCartOrderDetails } from '@/services/api/cart';

/*
 * PATCH Cart Order Details
 */
type UseUpdateCartOrderDetailsArgs = MutationObserverOptions<
  UpdateCartOrderDetailsResponse,
  AxiosError,
  UpdateCartOrderDetailsRequest
>;

export function useUpdateCartOrderDetails(options?: UseUpdateCartOrderDetailsArgs) {
  return useMutation({
    mutationFn: updateCartOrderDetails,
    ...options,
  });
}

/*
 * DELETE Cart Item
 */
type UseDeleteCartItemArgs = MutationObserverOptions<void, AxiosError, DeleteCartItemRequest>;

export function useDeleteCartItem(options?: UseDeleteCartItemArgs) {
  return useMutation({
    mutationFn: deleteItem,
    ...options,
  });
}
